module.exports = __webpack_public_path__ + "511ef49fcd7d049d9d2c9ff08d3d94a7.png";